/*
 * Webpack 5 Entry Point for CkEditor 5
 */
import {CkEditor5} from '@/vendor/ckeditor5/editor'
import {CkEditor5Initializer} from '@/vendor/ckeditor5/editor-initializer'

import "../../frontend/styles/vendor/ckeditor5/editor.scss";
import "../../frontend/styles/vendor/ckeditor5/fonts.scss";

/*
 * Run Initializer on eSearcher 3 'loadFinish',
 * i.e. the Page and/or Tab have finished loading.
 */
$(document).on('loadFinish', () => {
    CkEditor5Initializer(CkEditor5).initAll();
});

/*
 * Run Initializer on eSearcher 3 Slider Widget Dialog Loading completed,
 * necessary because Slider Widget has its own loading logic which does not trigger 'loadFinish'.
 */
$(document).on('sliderStepIsLoaded', () => {
    CkEditor5Initializer(CkEditor5).initAll();
});

/*
 * Custom Event Handler, can be used to run Initializer if a CkEditor 5 was added by hand.
 */
$(document).on('ckeditor5-reinitialize', () => {
    CkEditor5Initializer(CkEditor5).initAll();
});

if (module.hot) {
    module.hot.accept();
}
